/* ============================================================
   Growplex Persona Quiz — shared, data-driven engine
   Reads window.GP_PERSONA_QUIZ (set by a config file) and renders
   both the quiz flow and the full results page into #gpPersonaQuiz.
   Persona-agnostic: all copy/questions/results come from the config.
   ============================================================ */
(function () {
  'use strict';

  var CFG = window.GP_PERSONA_QUIZ;
  if (!CFG) { return; }

  /* Merge real product data injected by Shopify (overrides placeholders). */
  if (window.GP_QUIZ_PRODUCT_DATA) {
    CFG.products = Object.assign({}, CFG.products, window.GP_QUIZ_PRODUCT_DATA);
  }

  var root = document.getElementById('gpPersonaQuiz');
  if (!root) { return; }

  /* ---------- tiny DOM helper ---------- */
  function el(tag, attrs, kids) {
    var n = document.createElement(tag);
    if (attrs) {
      for (var k in attrs) {
        if (!attrs.hasOwnProperty(k)) continue;
        if (k === 'class') n.className = attrs[k];
        else if (k === 'html') n.innerHTML = attrs[k];
        else if (k === 'text') n.textContent = attrs[k];
        else if (k.indexOf('on') === 0 && typeof attrs[k] === 'function') n.addEventListener(k.slice(2), attrs[k]);
        else if (attrs[k] != null) n.setAttribute(k, attrs[k]);
      }
    }
    if (kids != null) {
      if (!Array.isArray(kids)) kids = [kids];
      kids.forEach(function (c) {
        if (c == null || c === false) return;
        n.appendChild(typeof c === 'string' ? document.createTextNode(c) : c);
      });
    }
    return n;
  }
  function svg(markup) {
    var wrap = document.createElement('div');
    wrap.innerHTML = markup.trim();
    return wrap.firstChild;
  }
  // Prices arrive in the shopper's currency (Shopify Markets), so the symbol follows it.
  // USD keeps the original "$84" / "$63.50" output.
  var CURRENCY = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
  function money(cents) {
    if (cents == null) return '';
    if (CURRENCY === 'USD') return '$' + (cents / 100).toFixed(2).replace(/\.00$/, '');
    var digits = cents % 100 === 0 ? 0 : 2;
    try {
      return new Intl.NumberFormat('en', { style: 'currency', currency: CURRENCY, currencyDisplay: 'narrowSymbol', minimumFractionDigits: digits, maximumFractionDigits: digits }).format(cents / 100);
    } catch (e) {
      return (cents / 100).toFixed(digits) + ' ' + CURRENCY;
    }
  }

  var REDUCED_MOTION = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- state ---------- */
  var screens = CFG.screens;
  var questionIds = screens.filter(function (s) { return s.type === 'single'; }).map(function (s) { return s.id; });

  var state = {
    answers: {},
    screenId: screens[0].id,
    history: [screens[0].id],
    completed: false,
    started: false,
    timerStart: null
  };

  try {
    var saved = JSON.parse(localStorage.getItem(CFG.storageKey) || 'null');
    if (saved && saved.answers) {
      state.answers = saved.answers;
      state.completed = !!saved.completed;
      state.started = !!saved.started;
      state.timerStart = saved.timerStart || null;
      if (saved.screenId && !state.completed) {
        state.screenId = saved.screenId;
        state.history = saved.history || [saved.screenId];
      }
    }
  } catch (e) {}

  function save() {
    try { localStorage.setItem(CFG.storageKey, JSON.stringify(state)); } catch (e) {}
  }

  function screenById(id) {
    for (var i = 0; i < screens.length; i++) if (screens[i].id === id) return screens[i];
    return null;
  }
  function indexOf(id) {
    for (var i = 0; i < screens.length; i++) if (screens[i].id === id) return i;
    return -1;
  }

  /* next screen id given current screen + answers (handles forks) */
  function nextId(screen) {
    if (screen.next && typeof screen.next === 'object') {
      var v = state.answers[screen.key];
      return screen.next[v] || screen.next._ || null;
    }
    if (typeof screen.next === 'string') return screen.next;
    var idx = indexOf(screen.id);
    return idx >= 0 && idx < screens.length - 1 ? screens[idx + 1].id : null;
  }

  /* ============================================================
     KLAVIYO (client-side, mirrors the live quiz's approach)
     ============================================================ */
  window.klaviyo = window.klaviyo || [];
  function kPush(a) { try { window.klaviyo.push(a); } catch (e) {} }
  function kFetch(url, opts, tries) {
    tries = tries == null ? 2 : tries;
    return fetch(url, opts).then(function (r) {
      if (!r.ok && tries > 1) return wait(700).then(function () { return kFetch(url, opts, tries - 1); });
      return r;
    }).catch(function () { if (tries > 1) return wait(700).then(function () { return kFetch(url, opts, tries - 1); }); });
  }
  function wait(ms) { return new Promise(function (r) { setTimeout(r, ms); }); }

  function quizProps() {
    var p = { 'Quiz Source': CFG.klaviyo.source, 'Quiz Persona': CFG.key };
    (CFG.screens).forEach(function (s) {
      if (s.type === 'single' && state.answers[s.key] != null) {
        /* fork siblings share a key: only the screen whose options contain
           the answer may label it (q3a vs q3b would otherwise clobber) */
        var match = (s.options || []).filter(function (o) { return o.value === state.answers[s.key]; })[0];
        var name = 'Quiz ' + (s.prop || s.key);
        if (match) p[name] = match.label;
        else if (p[name] == null) p[name] = state.answers[s.key];
      }
    });
    if (state.answers.name) p['Quiz First Name'] = state.answers.name;
    if (GPX && GPX.code) p['Quiz Test Arm'] = GPX.code;
    p['Quiz Completed At'] = new Date().toISOString();
    return p;
  }
  function labelFor(screen, value) {
    var opt = (screen.options || []).filter(function (o) { return o.value === value; })[0];
    return opt ? opt.label : value;
  }
  function kIdentify(extra) {
    var t = quizProps();
    if (state.answers.email) t.$email = state.answers.email;
    if (state.answers.name) t.$first_name = state.answers.name;
    if (extra) Object.assign(t, extra);
    kPush(['identify', t]);
  }
  function kTrack(metric, props) { kPush(['track', metric, props || {}]); }
  function kSubscribe() {
    var e = state.answers.email;
    if (!e || !CFG.klaviyo.listId) return;
    var attrs = { email: e, properties: quizProps(), subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } } };
    if (state.answers.name) attrs.first_name = state.answers.name;
    var body = { data: { type: 'subscription', attributes: {
      custom_source: CFG.klaviyo.source,
      profile: { data: { type: 'profile', attributes: attrs } }
    }, relationships: { list: { data: { type: 'list', id: CFG.klaviyo.listId } } } } };
    kFetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + CFG.klaviyo.companyId, {
      method: 'POST', headers: { 'Content-Type': 'application/json', revision: '2026-04-15' },
      body: JSON.stringify(body), keepalive: true
    });
  }

  /* ============================================================
     GP-QUIZ PIPELINE (our own endpoint)

     Klaviyo stays exactly as it was: it owns identity, list membership and
     flow triggers. It cannot own the funnel, because its onsite JS holds an
     unidentified visitor's events in localStorage and only ships them once
     that visitor gives an email. Everyone who abandons first is discarded.

     gpTrack posts to our Worker instead, on every screen, and flushes on
     pagehide, so abandonment is recorded rather than lost.
     ============================================================ */
  var GP_ENDPOINT = CFG.trackEndpoint || window.GP_QUIZ_TRACK_ENDPOINT || 'https://quiz.growplex.co/e';

  /* A/B test running on this page (snippets/gpx-experiment.liquid, 2026-10-01).
     When present, the tracker sends the exact quiz version this visitor loaded
     and the arm's code, and the extra events Kisha's tests read are switched
     on: screen_visible, result_viewed, offer_viewed, checkout_started. Pages
     without a test send exactly what they sent before. */
  var GPX = (window.GPX && window.GPX.quiz === (CFG.__slug || CFG.key)) ? window.GPX : null;

  function gpTrackInit() {
    try {
      if (!window.GPQuizTrack) return;
      window.GPQuizTrack.init({
        endpoint: GP_ENDPOINT,
        quiz: CFG.__slug || CFG.key,
        version: CFG.__version || (GPX ? GPX.version : 0),
        lp_code: GPX ? GPX.code : '',
        lp_qa: GPX ? GPX.qa : 0
      });
    } catch (e) {}
  }

  /* Runs fn once the page is actually showing: after the next painted frame,
     and not while the tab is in the background. */
  function whenShown(fn) {
    function go() {
      requestAnimationFrame(function () { requestAnimationFrame(fn); });
    }
    if (document.visibilityState !== 'hidden') { go(); return; }
    document.addEventListener('visibilitychange', function onVis() {
      if (document.visibilityState === 'hidden') return;
      document.removeEventListener('visibilitychange', onVis);
      go();
    });
  }

  function gpTrack(name, props) {
    try { if (window.GPQuizTrack) window.GPQuizTrack.track(name, props || {}); } catch (e) {}
  }

  /* ============================================================
     QUIZ RENDER
     ============================================================ */
  var animating = false;

  /* Transition constants — mirror the live quiz (custom-quiz-inline):
     brisk ease-in exit, longer expo-out entrance, directional. */
  var EASE_OUT_EXPO = 'cubic-bezier(0.16, 1, 0.3, 1)';
  var EASE_IN = 'cubic-bezier(0.4, 0, 1, 1)';
  var EXIT_MS = 260, ENTER_MS = 440;

  function render(id, back) {
    var screen = screenById(id);
    if (!screen) return;
    state.screenId = id;
    save();

    var view = buildScreen(screen);
    swap(view, back, function () {
      /* loading animation must start AFTER the screen is in the DOM */
      if (screen.type === 'loading') runLoading(screen);
      /* photos a config marks deferImages wait until the question is on screen */
      if (view.querySelector('img[data-gpq-src]')) {
        whenShown(function () {
          view.querySelectorAll('img[data-gpq-src]').forEach(function (img) {
            img.src = img.getAttribute('data-gpq-src');
            img.removeAttribute('data-gpq-src');
          });
        });
      }
      if (GPX) {
        whenShown(function () {
          if (state.screenId !== screen.id) return; /* already moved on */
          gpTrack('screen_visible', {
            screen_id: screen.id,
            screen_type: screen.type,
            step_index: indexOf(screen.id),
            label: screen.prop || screen.key || null
          });
        });
      }
    });

    /* Klaviyo keeps its question-only funnel (existing segments depend on
       those metric names). gpTrack records EVERY screen, including the
       education and statement beats where cold paid traffic bounces. */
    if (screen.type === 'single') kTrack('Quiz Step Viewed', { step: screen.prop || screen.key, persona: CFG.key });
    gpTrack('screen_viewed', {
      screen_id: screen.id,
      screen_type: screen.type,
      step_index: indexOf(screen.id),
      label: screen.prop || screen.key || null
    });
    if (screen.type === 'capture' || screen.type === 'name') setTimeout(focusFirst, EXIT_MS + ENTER_MS + 60);
  }

  function focusFirst() { var i = root.querySelector('.gpq-input'); if (i) i.focus(); }

  /* Staggered text reveal on insight screens (live-quiz pattern):
     each [data-reveal] fades up 200ms after the screen enters, 280ms apart. */
  function revealStagger(view) {
    var els = Array.prototype.slice.call(view.querySelectorAll('[data-reveal]'));
    if (!els.length) return;
    els.forEach(function (n) { n.classList.remove('is-revealed'); });
    if (REDUCED_MOTION) { els.forEach(function (n) { n.classList.add('is-revealed'); }); return; }
    els.forEach(function (n) {
      var i = parseInt(n.getAttribute('data-reveal'), 10) || 0;
      setTimeout(function () { n.classList.add('is-revealed'); }, 200 + i * 280);
    });
  }

  function swap(view, back, onEntered) {
    var cur = root.querySelector('.gpq-screen');
    if (!cur || REDUCED_MOTION) {
      root.querySelectorAll('.gpq-screen').forEach(function (n) { if (n.parentNode) n.parentNode.removeChild(n); });
      root.appendChild(view);
      view.classList.add('is-in');
      revealStagger(view);
      if (onEntered) onEntered();
      return;
    }
    animating = true;

    /* Phase 1: gracefully exit the current screen */
    cur.style.transition = 'opacity ' + EXIT_MS + 'ms ' + EASE_IN + ', transform ' + EXIT_MS + 'ms ' + EASE_IN;
    cur.style.opacity = '0';
    cur.style.transform = 'translateY(' + (back ? '14px' : '-14px') + ')';

    /* Phase 2: after the exit completes, bring the new screen in off-stage */
    setTimeout(function () {
      /* remove every screen node, not just `cur` — defends against zombies */
      root.querySelectorAll('.gpq-screen').forEach(function (n) { if (n.parentNode) n.parentNode.removeChild(n); });
      view.style.opacity = '0';
      view.style.transform = 'translateY(' + (back ? '-24px' : '24px') + ')';
      view.style.transition = 'none';
      root.appendChild(view);
      void view.offsetWidth; /* force reflow so the entrance animates */
      view.style.transition = 'opacity ' + ENTER_MS + 'ms ' + EASE_OUT_EXPO + ', transform ' + ENTER_MS + 'ms ' + EASE_OUT_EXPO;
      view.classList.add('is-in');
      view.style.opacity = '1';
      view.style.transform = 'translateY(0)';
      setTimeout(function () {
        view.style.transition = ''; view.style.opacity = ''; view.style.transform = '';
        animating = false;
      }, ENTER_MS + 20);
      revealStagger(view);
      if (onEntered) onEntered();
    }, EXIT_MS + 30);
  }

  function chrome(screen, bodyKids, footer) {
    var showBack = state.history.length > 1 && screen.type !== 'loading';
    var pct = progressPct(screen);
    return el('div', { class: 'gpq-screen gpq-screen--' + screen.type }, [
      el('div', { class: 'gpq-top' }, [
        CFG.showBrand === false ? null : el('div', { class: 'gpq-brand' }, CFG.brand || 'growplex'),
        pct != null ? el('div', { class: 'gpq-progress', role: 'progressbar', 'aria-label': 'Quiz progress', 'aria-valuemin': '0', 'aria-valuemax': '100', 'aria-valuenow': String(pct) }, el('div', { class: 'gpq-progress-fill', style: 'width:' + pct + '%' })) : null,
        showBack ? el('button', { class: 'gpq-back', 'aria-label': 'Back', onclick: goBack }, [
          svg('<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M19 12H5"/><path d="M12 19l-7-7 7-7"/></svg>'), 'Back'
        ]) : el('span', { class: 'gpq-back gpq-back--ghost' })
      ]),
      el('div', { class: 'gpq-body' }, bodyKids),
      footer || null
    ]);
  }

  function progressPct(screen) {
    if (screen.type === 'start' || screen.type === 'loading' || screen.type === 'capture' || screen.type === 'name') return null;
    var lastQ = 0, seen = 0;
    for (var i = 0; i <= indexOf(screen.id); i++) {
      if (screens[i].type === 'single') seen++;
    }
    if (screen.type === 'insight') { /* keep bar where last question left it */ }
    var total = questionIds.length;
    var frac = seen / total;
    /* accelerate in the back half */
    frac = frac < 0.5 ? frac * 0.9 : 0.45 + (frac - 0.5) * 1.1;
    return Math.max(6, Math.min(100, Math.round(frac * 100)));
  }

  function buildScreen(screen) {
    if (screen.type === 'start') return buildStart(screen);
    if (screen.type === 'single') return buildSingle(screen);
    if (screen.type === 'insight') return buildInsight(screen);
    if (screen.type === 'stat') return buildStat(screen);
    if (screen.type === 'statement') return buildStatement(screen);
    if (screen.type === 'list') return buildList(screen);
    if (screen.type === 'proof') return buildProof(screen);
    if (screen.type === 'loading') return buildLoading(screen);
    if (screen.type === 'name') return buildName(screen);
    if (screen.type === 'capture') return buildCapture(screen);
    return el('div', { class: 'gpq-screen' });
  }

  /* ---- PSL-pattern screens (educational stat card, statement beat,
          consequence list, proof interstitial) ---- */
  function buildStat(s) {
    var chart = null;
    if (s.chart && s.chart.bars) {
      chart = el('div', { 'data-reveal': '1' }, statChart(s.chart));
    }
    return chrome(s, [
      el('div', { class: 'gpq-insight gpq-statcard' }, [
        s.kicker ? el('div', { class: 'gpq-insight-kicker', 'data-reveal': '0' }, s.kicker) : null,
        el('h2', { class: 'gpq-insight-title', 'data-reveal': '0', html: s.headline }),
        chart,
        s.body ? el('p', { class: 'gpq-insight-body', 'data-reveal': '2', html: s.body }) : null
      ])
    ], el('div', { class: 'gpq-foot' }, el('button', { class: 'gpq-btn gpq-btn--pill', onclick: function () { advance(s); } }, s.button || 'Next')));
  }

  /* statement-card visuals (dark- or light-card friendly) */
  /* resolve a generated-image asset name against the theme asset CDN base;
     keep the ?v= version query so image URLs get cache-busted on deploys
     (unversioned asset URLs can pin a stale CDN edge variant) */
  function assetUrl(name) {
    var b = window.GP_QUIZ_ASSET_BASE || '';
    if (!b) return name;
    return b.replace(/persona-quiz-engine\.js(\?[^#]*)?$/, function (m, q) { return name + (q || ''); });
  }

  function statementVisual(v) {
    if (v && v.type === 'image') {
      var kids = [el('div', { class: 'gpq-simg' }, el('img', { src: v.src || assetUrl(v.asset), alt: v.alt || '', loading: 'lazy' }))];
      if (v.labels) kids.push(el('div', { class: 'gpq-months-labels' }, [
        el('span', {}, v.labels.a || ''),
        el('span', { class: 'gpq-months-mid' }, v.labels.mid || ''),
        el('span', {}, v.labels.b || '')
      ]));
      return el('div', {}, kids);
    }
    if (!v) return null;
    /* month-strip: trigger event → hairs quietly pause (look normal) → TODAY they shed.
       The hidden middle phase IS the insight, so it is drawn, not implied. */
    if (v.type === 'months') {
      return el('div', { class: 'gpq-months' }, [
        svg('<svg viewBox="0 0 320 116" fill="none">' +
          '<path class="gpq-draw" pathLength="1" d="M16 78 L304 78" stroke="rgba(244,242,236,.32)" stroke-width="2" stroke-linecap="round"/>' +
          '<line class="gpq-m gpq-m1" x1="40" y1="78" x2="40" y2="84" stroke="rgba(244,242,236,.4)" stroke-width="2"/>' +
          '<line class="gpq-m gpq-m2" x1="106" y1="78" x2="106" y2="84" stroke="rgba(244,242,236,.4)" stroke-width="2"/>' +
          '<line class="gpq-m gpq-m3" x1="172" y1="78" x2="172" y2="84" stroke="rgba(244,242,236,.4)" stroke-width="2"/>' +
          '<line class="gpq-m gpq-m4" x1="238" y1="78" x2="238" y2="84" stroke="rgba(244,242,236,.4)" stroke-width="2"/>' +
          '<path class="gpq-m gpq-m1" d="M40 78 C37 58 43 44 40 28" stroke="#f4f2ec" stroke-width="3" stroke-linecap="round"/>' +
          '<circle class="gpq-m gpq-m1" cx="40" cy="78" r="5.5" fill="#d29a52"/>' +
          '<path class="gpq-m gpq-m2" d="M106 78 C103 58 109 44 106 28" stroke="#d29a52" stroke-width="3" stroke-linecap="round"/>' +
          '<path class="gpq-m gpq-m3" d="M172 78 C169 58 175 44 172 28" stroke="#d29a52" stroke-width="3" stroke-linecap="round"/>' +
          '<path class="gpq-m gpq-m4" d="M228 58 C237 50 245 42 252 33" stroke="#d29a52" stroke-width="3" stroke-linecap="round" opacity="0.9"/>' +
          '<path class="gpq-m gpq-m5" d="M280 62 C287 54 293 47 298 39" stroke="#f4f2ec" stroke-width="3" stroke-linecap="round" opacity="0.9"/>' +
          '<path class="gpq-m gpq-m5" d="M294 46 C298 40 301 34 303 28" stroke="#f4f2ec" stroke-width="2.5" stroke-linecap="round" opacity="0.55"/>' +
          '<rect class="gpq-m gpq-m5" x="252" y="6" width="56" height="20" rx="10" fill="#f4f2ec"/>' +
          '<text class="gpq-m gpq-m5" x="280" y="20" text-anchor="middle" font-family="Inter, sans-serif" font-size="9.5" font-weight="800" letter-spacing="1" fill="#1b2a30">TODAY</text>' +
          '</svg>'),
        el('div', { class: 'gpq-months-labels' }, [
          el('span', {}, v.a || ''),
          el('span', { class: 'gpq-months-mid' }, v.mid || ''),
          el('span', {}, v.b || '')
        ])
      ]);
    }
    /* scalp cross-section: hair gone ABOVE the skin, follicles intact BELOW it */
    if (v.type === 'scalp') {
      return el('div', { class: 'gpq-scalp' }, [
        svg('<svg viewBox="0 0 300 152" fill="none">' +
          '<rect x="12" y="86" width="276" height="56" rx="12" fill="#f1efe8"/>' +
          '<line x1="24" y1="86" x2="276" y2="86" stroke="#e0d9c8" stroke-width="2"/>' +
          /* left + right: hair standing above the skin */
          '<path d="M75 86 C72 62 78 44 74 26" stroke="#55636a" stroke-width="3.5" stroke-linecap="round"/>' +
          '<path d="M225 86 C228 62 222 44 226 26" stroke="#55636a" stroke-width="3.5" stroke-linecap="round"/>' +
          /* middle: the hair floated away… */
          '<path d="M158 34 C165 27 171 20 176 13" stroke="#b9b2a2" stroke-width="3" stroke-linecap="round"/>' +
          '<path d="M143 24 C148 18 152 13 155 7" stroke="#c7c0b0" stroke-width="2.5" stroke-linecap="round"/>' +
          /* …but every follicle below the skin is intact; middle one glows + new nub */
          '<circle class="gpq-scalp-glow" cx="150" cy="118" r="18" fill="#4f9078" opacity="0.13"/>' +
          '<line x1="75" y1="92" x2="75" y2="112" stroke="#4f9078" stroke-width="3.5" stroke-linecap="round"/>' +
          '<circle cx="75" cy="119" r="7" fill="#4f9078"/>' +
          '<line x1="225" y1="92" x2="225" y2="112" stroke="#4f9078" stroke-width="3.5" stroke-linecap="round"/>' +
          '<circle cx="225" cy="119" r="7" fill="#4f9078"/>' +
          '<line x1="150" y1="92" x2="150" y2="111" stroke="#4f9078" stroke-width="3.5" stroke-linecap="round"/>' +
          '<circle cx="150" cy="118" r="8" fill="#4f9078"/>' +
          '<line x1="150" y1="86" x2="150" y2="77" stroke="#4f9078" stroke-width="3" stroke-linecap="round"/>' +
          '</svg>'),
        legendRow([{ label: 'The hair shed', color: 'muted' }, { label: 'The follicle stayed', color: 'teal' }])
      ]);
    }
    /* briefing checklist rows, staggered in via CSS delays */
    if (v.type === 'checklist') {
      return el('div', { class: 'gpq-brief' }, (v.items || []).map(function (it) {
        return el('div', { class: 'gpq-brief-row' }, [
          el('span', { class: 'gpq-brief-check' }, svg('<svg viewBox="0 0 14 14" fill="none"><path d="M2 7l3.5 3.5L12 4" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>')),
          el('span', {}, it)
        ]);
      }));
    }
    return null;
  }

  function buildStatement(s) {
    var vis = statementVisual(s.visual);
    var idx = 0;
    var inner = [];
    if (vis) inner.push(el('div', { class: 'gpq-stmt-vis', 'data-reveal': String(idx++) }, vis));
    if (s.lines && s.lines.length) {
      s.lines.forEach(function (ln) {
        inner.push(el('p', { class: 'gpq-statement-text', 'data-reveal': String(idx++), html: ln }));
      });
    } else {
      inner.push(el('p', { class: 'gpq-statement-text', 'data-reveal': String(idx++), html: s.text }));
    }
    if (s.sub) inner.push(el('p', { class: 'gpq-statement-sub', 'data-reveal': String(idx++), html: s.sub }));
    return chrome(s, [
      el('div', { class: 'gpq-statement' }, [
        el('div', { class: 'gpq-statement-card' + (s.variant === 'light' ? ' gpq-statement-card--light' : '') }, inner)
      ])
    ], el('div', { class: 'gpq-foot' }, el('button', { class: 'gpq-btn gpq-btn--pill', onclick: function () { advance(s); } }, s.button || 'Continue')));
  }

  /* per-consequence glyphs: each item depicts ITS OWN failure mode, not a generic warning */
  var LIST_ICONS = {
    /* supply arrow stops above a broken line: nutrients not arriving */
    gap: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 4v5"/><path d="M9.8 7.2L12 9.4l2.2-2.2"/><path d="M3 15h6"/><path d="M15 15h6"/><line x1="11.2" y1="15" x2="11.21" y2="15"/><line x1="13" y1="15" x2="13.01" y2="15"/></svg>',
    /* clock: follicles stuck waiting */
    wait: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="8.25"/><path d="M12 7.8V12l2.7 2.2"/></svg>',
    /* outward arrows: the window being pulled longer */
    stretch: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M9.5 12H3"/><path d="M5.8 9.2L3 12l2.8 2.8"/><path d="M14.5 12H21"/><path d="M18.2 9.2L21 12l-2.8 2.8"/><line x1="12" y1="9.5" x2="12" y2="14.5"/></svg>',
    /* fallback */
    warn: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/><line x1="12" y1="9" x2="12" y2="13"/><line x1="12" y1="17" x2="12.01" y2="17"/></svg>'
  };

  function buildList(s) {
    return chrome(s, [
      el('div', { class: 'gpq-listwrap' }, [
        s.kicker ? el('div', { class: 'gpq-insight-kicker' }, s.kicker) : null,
        el('h2', { class: 'gpq-insight-title gpq-list-title', html: s.headline }),
        s.sub ? el('p', { class: 'gpq-qsub', html: s.sub }) : null,
        s.visual ? el('div', { class: 'gpq-list-vis', 'data-reveal': '0' }, statementVisual(s.visual)) : null,
        el('div', { class: 'gpq-list' }, (s.items || []).map(function (it, i) {
          var text = typeof it === 'string' ? it : it.text;
          var icon = it && it.icon;
          return el('div', { class: 'gpq-list-item', 'data-reveal': String(i + (s.visual ? 1 : 0)) }, [
            icon ? el('span', { class: 'gpq-list-tile' }, svg('<svg class="gpq-list-ic"' + (LIST_ICONS[icon] || LIST_ICONS.warn).slice('<svg'.length)))
                 : el('span', { class: 'gpq-list-dash' }),
            el('span', { html: text })
          ]);
        })),
        s.footnote ? el('p', { class: 'gpq-list-note', html: s.footnote }) : null
      ])
    ], el('div', { class: 'gpq-foot' }, el('button', { class: 'gpq-btn gpq-btn--pill', onclick: function () { advance(s); } }, s.button || 'Continue')));
  }

  function buildProof(s) {
    /* running reveal index: kicker + headline occupy 0, then any strips and
       quotes continue the stagger so the card animates in top-to-bottom order. */
    var ri = 1;
    var inner = [
      s.kicker ? el('div', { class: 'gpq-insight-kicker', 'data-reveal': '0' }, s.kicker) : null,
      el('h2', { class: 'gpq-insight-title', 'data-reveal': '0', html: s.headline }),
      s.trustLine ? el('div', { class: 'gpq-proof-trust', 'data-reveal': String(ri++) }, s.trustLine) : null
    ];
    /* generated before/after strips (LEFT half before, RIGHT half after, flush at center) */
    if (s.pairs && s.pairs.length) {
      inner.push(el('div', { class: 'gpq-proof-strips' }, s.pairs.map(function (p) {
        return el('div', { class: 'gpq-proof-strip', 'data-reveal': String(ri++) }, [
          el('img', { src: assetUrl(p.asset), alt: p.alt || '', loading: 'lazy' }),
          el('span', { class: 'gpr-ba-tag' }, 'Before'),
          el('span', { class: 'gpr-ba-tag gpr-ba-tag--after' }, 'After')
        ]);
      })));
    }
    inner.push(el('div', { class: 'gpq-proof-quotes' }, (s.quotes || []).map(function (q) {
      return el('div', { class: 'gpq-proof-quote', 'data-reveal': String(ri++) }, [
        (q.before || q.after) ? el('div', { class: 'gpq-proof-imgs' }, [
          q.before ? el('span', { class: 'gpq-proof-img', style: 'background-image:url(' + q.before + ')' + (q.beforeFit || '') }, el('span', { class: 'gpr-ba-tag' }, 'Before')) : null,
          q.after ? el('span', { class: 'gpq-proof-img', style: 'background-image:url(' + q.after + ')' + (q.afterFit || '') }, el('span', { class: 'gpr-ba-tag gpr-ba-tag--after' }, 'After')) : null
        ]) : null,
        el('div', { class: 'gpr-stars' }, stars(5)),
        el('p', { html: '"' + q.quote + '"' }),
        el('div', { class: 'gpq-proof-by' }, (q.name || '') + ' · Verified buyer' + ((q.before || q.after) ? ' · verified customer photos' : ''))
      ]);
    })));
    return chrome(s, [
      el('div', { class: 'gpq-proof' }, inner)
    ], el('div', { class: 'gpq-foot' }, el('button', { class: 'gpq-btn gpq-btn--pill', onclick: function () { advance(s); } }, s.button || 'Continue')));
  }

  function buildStart(s) {
    return chrome(s, [
      el('div', { class: 'gpq-start' }, [
        s.eyebrow ? el('div', { class: 'gpq-eyebrow' }, s.eyebrow) : null,
        el('h1', { class: 'gpq-start-title', html: s.headline }),
        el('p', { class: 'gpq-start-sub', html: s.subhead }),
        el('button', { class: 'gpq-btn gpq-btn--pill', onclick: function () { advance(s); } }, s.button || 'Start')
      ])
    ]);
  }

  /* "Question N of M" — fork siblings share a key, so count unique keys */
  function questionNumber(screen) {
    var totalKeys = {}, total = 0, numKeys = {}, num = 0;
    screens.forEach(function (s) { if (s.type === 'single' && !totalKeys[s.key]) { totalKeys[s.key] = 1; total++; } });
    for (var i = 0; i <= indexOf(screen.id); i++) {
      var s = screens[i];
      if (s.type === 'single' && !numKeys[s.key]) { numKeys[s.key] = 1; num++; }
    }
    return 'Question ' + num + ' of ' + total;
  }

  function buildSingle(s) {
    var opts = el('div', { class: 'gpq-options', role: 'radiogroup', 'aria-labelledby': 'gpqQuestion' }, (s.options || []).map(function (o) {
      var selected = state.answers[s.key] === o.value;
      return el('button', { class: 'gpq-option' + (selected ? ' is-selected' : ''), role: 'radio', 'aria-checked': selected ? 'true' : 'false', onclick: function () { pick(s, o); } }, [
        o.icon ? el('span', { class: 'gpq-option-icon', html: o.icon }) : null,
        el('span', { class: 'gpq-option-tg' }, [
          el('span', { class: 'gpq-option-label', html: o.label }),
          o.sub ? el('span', { class: 'gpq-option-sub', html: o.sub }) : null
        ]),
        el('span', { class: 'gpq-radio' })
      ]);
    }));
    return chrome(s, [
      s.heading ? el('h1', { class: 'gpq-lead-title', html: s.heading }) : null,
      s.lede ? el('p', { class: 'gpq-lead-sub', html: s.lede }) : null,
      el('div', { class: 'gpq-qnum' }, questionNumber(s)),
      el('h2', { class: 'gpq-question', id: 'gpqQuestion', html: s.question }),
      s.subtitle ? el('p', { class: 'gpq-qsub', html: s.subtitle }) : null,
      opts,
      s.proof ? inlineProof(s.proof) : null
    ]);
  }

  /* Proof block that lives under a question instead of on its own screen.
     The before/after pairs are a real carousel: one captioned card per pair,
     dots and a live counter, prev/next for mouse users, swipe on touch. Each
     card is one photo split down the middle, so the caption and the "1 of 4"
     label are what tell a first-time viewer that the two halves belong together. */
  function inlineProof(pf) {
    var kids = [];
    if (pf.kicker) kids.push(el('div', { class: 'gpq-inline-proof-kicker' }, pf.kicker));
    if (pf.pairs && pf.pairs.length) kids.push(pairCarousel(pf.pairs, pf));
    /* optional line under the photos, e.g. where they come from and that results vary */
    if (pf.note) kids.push(el('p', { class: 'gpr-ba-cap gpq-inline-proof-note' }, pf.note));
    if (pf.quotes && pf.quotes.length) {
      kids.push(el('div', { class: 'gpq-proof-quotes' }, pf.quotes.map(function (q) {
        return el('div', { class: 'gpq-proof-quote' }, [
          el('div', { class: 'gpr-stars' }, stars(5)),
          el('p', { html: '"' + q.quote + '"' }),
          el('div', { class: 'gpq-proof-by' }, (q.name || '') + ' · Verified buyer')
        ]);
      })));
    }
    return el('div', { class: 'gpq-inline-proof' }, kids);
  }

  function pairCarousel(pairs, opts) {
    var n = pairs.length, active = 0, dots = [], counter, track, prevBtn, nextBtn;
    /* opts.deferImages (2026-10-01, Kisha's GLP-1 test): the photos load after the
       question is on screen instead of competing with it. opts.imageSize
       [w, h] reserves their box so nothing below them moves when they arrive. */
    var defer = !!(opts && opts.deferImages);
    var size = (opts && opts.imageSize) || null;
    function stripImg(p, i) {
      var a = { alt: p.alt || '', decoding: 'async' };
      if (size) { a.width = size[0]; a.height = size[1]; }
      if (defer) { a['data-gpq-src'] = assetUrl(p.asset); a.loading = 'eager'; a.fetchpriority = 'low'; }
      else { a.src = assetUrl(p.asset); a.loading = i < 2 ? 'eager' : 'lazy'; }
      return el('img', a);
    }
    function arrow(dir) {
      return svg(dir < 0
        ? '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M15 18l-6-6 6-6"/></svg>'
        : '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M9 6l6 6-6 6"/></svg>');
    }
    /* Instant paging on purpose: Chrome cancels smooth programmatic scrolls on a
       mandatory-snap track and leaves it where it was. An instant scroll lands on
       the snap point every time; touch users still get native swipe momentum. */
    function goTo(i) {
      i = Math.max(0, Math.min(n - 1, i));
      setActive(i); /* dots and counter follow the intent at once; the scroll event only corrects finger swipes */
      var it = track.children[i];
      if (it && it.scrollIntoView) it.scrollIntoView({ behavior: 'auto', block: 'nearest', inline: 'start' });
    }
    function setActive(i) {
      if (i === active) return;
      active = i;
      dots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); d.setAttribute('aria-current', k === i ? 'true' : 'false'); });
      counter.textContent = (i + 1) + ' / ' + n;
      prevBtn.disabled = i === 0; nextBtn.disabled = i === n - 1;
    }
    track = el('div', { class: 'gpq-carousel', role: 'region', 'aria-roledescription': 'carousel', 'aria-label': 'Customer before and after photos', tabindex: '0' },
      pairs.map(function (p, i) {
        return el('div', { class: 'gpq-carousel-item', role: 'group', 'aria-roledescription': 'slide', 'aria-label': (i + 1) + ' of ' + n }, [
          el('div', { class: 'gpq-proof-strip' }, [
            stripImg(p, i),
            el('span', { class: 'gpr-ba-tag' }, 'Before'),
            el('span', { class: 'gpr-ba-tag gpr-ba-tag--after' }, 'After'),
            el('span', { class: 'gpq-slide-num' }, (i + 1) + ' of ' + n)
          ]),
          (p.caption || p.alt) ? el('div', { class: 'gpq-slide-cap' }, p.caption || p.alt) : null
        ]);
      }));
    /* Active card from scroll position. Snap points sit at whole strides, so
       rounding is exact. (An intersection observer built here would be inert:
       the engine assembles a screen before attaching it to the document.) */
    function stride() { var a = track.children[0], b = track.children[1]; return (a && b) ? (b.offsetLeft - a.offsetLeft) || 1 : 1; }
    /* synchronous on purpose: setActive is four class toggles, and a background
       tab throttles requestAnimationFrame so the dots would lag behind the card */
    track.addEventListener('scroll', function () { setActive(Math.round(track.scrollLeft / stride())); }, { passive: true });
    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); goTo(active + 1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); goTo(active - 1); }
    });
    prevBtn = el('button', { class: 'gpq-carousel-btn', type: 'button', 'aria-label': 'Previous photo', onclick: function () { goTo(active - 1); } }, arrow(-1));
    nextBtn = el('button', { class: 'gpq-carousel-btn', type: 'button', 'aria-label': 'Next photo', onclick: function () { goTo(active + 1); } }, arrow(1));
    prevBtn.disabled = true;
    for (var k = 0; k < n; k++) {
      (function (k) {
        var d = el('button', { class: 'gpq-carousel-dot' + (k === 0 ? ' is-active' : ''), type: 'button', 'aria-label': 'Go to photo ' + (k + 1), 'aria-current': k === 0 ? 'true' : 'false', onclick: function () { goTo(k); } });
        dots.push(d);
      })(k);
    }
    counter = el('span', { class: 'gpq-carousel-count', 'aria-live': 'polite' }, '1 / ' + n);
    var nav = el('div', { class: 'gpq-carousel-nav' }, [
      prevBtn,
      el('div', { class: 'gpq-carousel-dots' }, dots),
      counter,
      nextBtn
    ]);
    return el('div', { class: 'gpq-carousel-wrap' + (n > 1 ? '' : ' gpq-carousel-wrap--single') }, [track, nav]);
  }

  /* ---- insight visuals: small brand graphics that support the text ---- */
  function statChart(chart) {
    return el('div', { class: 'gpq-stat-chart' }, (chart.bars || []).map(function (b) {
      return el('div', { class: 'gpq-stat-row' }, [
        el('span', { class: 'gpq-stat-label' }, b.label),
        el('span', { class: 'gpq-stat-track' }, el('span', { class: 'gpq-stat-fill' + (b.color === 'amber' ? ' gpq-stat-fill--amber' : ''), style: 'width:' + Math.max(4, Math.min(100, b.pct)) + '%' })),
        el('span', { class: 'gpq-stat-pct' }, b.pctLabel || (b.pct + '%'))
      ]);
    }).concat(chart.source ? [el('div', { class: 'gpq-stat-source' }, chart.source)] : []));
  }

  function legendRow(items) {
    return el('div', { class: 'gpq-ivis-legend' }, items.map(function (it) {
      return el('span', { class: 'gpq-ivis-legend-item' }, [
        el('span', { class: 'gpq-ivis-dot' + (it.color === 'amber' ? ' gpq-ivis-dot--amber' : it.color === 'muted' ? ' gpq-ivis-dot--muted' : '') }),
        it.label
      ]);
    }));
  }

  function insightVisual(v) {
    if (!v) return null;
    /* reuse the results mechanism graphic (bars / shrinking follicles) */
    if (v.type === 'mech') return el('div', { class: 'gpq-ivis-mech' }, mechanismGraphic({ type: v.mode, stages: v.stages }));
    /* reuse the stat chart (ranked horizontal bars) */
    if (v.type === 'chart') return statChart(v);
    /* two side-by-side sparkline panels: sudden spike vs gradual slope */
    if (v.type === 'spark') {
      var SPIKE = 'M6 50 C30 48 44 46 58 30 C68 18 74 10 82 12 C92 16 100 38 116 46 C126 50 134 51 142 51';
      var SLOPE = 'M6 48 C40 44 70 38 100 28 C118 22 130 17 142 12';
      function panel(p, style) {
        var isSpike = style === 'spike';
        return el('div', { class: 'gpq-spark-panel' }, [
          svg('<svg viewBox="0 0 148 58" fill="none"><path class="gpq-draw" pathLength="1" d="' + (isSpike ? SPIKE : SLOPE) + '" stroke="' + (p.color === 'teal' ? '#4f9078' : '#c2823a') + '" stroke-width="3" stroke-linecap="round"/></svg>'),
          el('div', { class: 'gpq-spark-label' }, p.label)
        ]);
      }
      return el('div', {}, [
        el('div', { class: 'gpq-spark' }, [panel(v.a, v.a.style || 'spike'), panel(v.b, v.b.style || 'slope')]),
        v.caption ? el('div', { class: 'gpq-spark-cap' }, v.caption) : null
      ]);
    }
    /* dot grid: you're not alone */
    if (v.type === 'dots') {
      var dots = '';
      for (var r = 0; r < 4; r++) for (var c = 0; c < 12; c++) {
        var lit = ((r * 12 + c) % 7 !== 3); /* most dots highlighted */
        dots += '<circle cx="' + (12 + c * 22) + '" cy="' + (10 + r * 21) + '" r="5.5" fill="' + (lit ? '#4f9078' : '#d8d2c4') + '" opacity="' + (lit ? '0.85' : '1') + '"/>';
      }
      return el('div', { class: 'gpq-ivis-dots' }, [
        svg('<svg viewBox="0 0 266 82" fill="none">' + dots + '</svg>'),
        v.caption ? el('div', { class: 'gpq-spark-label' }, v.caption) : null
      ]);
    }
    /* ascending curve with a "most quit here" marker before results show */
    if (v.type === 'curveQuit') {
      return el('div', { class: 'gpq-ivis-curve' }, [
        svg('<svg viewBox="0 0 300 96" fill="none">' +
          '<path class="gpq-draw" pathLength="1" d="M14 82 C70 80 110 74 160 56 C210 38 250 24 286 16" stroke="#4f9078" stroke-width="3" stroke-linecap="round"/>' +
          '<circle cx="86" cy="76" r="6" fill="#c2823a"/>' +
          '<circle cx="266" cy="20" r="6" fill="#4f9078"/>' +
          '</svg>'),
        legendRow([{ label: v.quitLabel || 'Most people quit here', color: 'amber' }, { label: v.winLabel || 'Visible change', color: 'teal' }])
      ]);
    }
    /* two diverging curves: start now vs wait */
    if (v.type === 'curveCompare') {
      return el('div', { class: 'gpq-ivis-curve' }, [
        svg('<svg viewBox="0 0 300 96" fill="none">' +
          '<path class="gpq-draw" pathLength="1" d="M14 78 C80 74 140 56 200 38 C240 27 268 20 286 16" stroke="#4f9078" stroke-width="3" stroke-linecap="round"/>' +
          '<path d="M14 78 C90 78 170 76 286 68" stroke="#c2823a" stroke-width="3" stroke-linecap="round" stroke-dasharray="1 7"/>' +
          '</svg>'),
        legendRow([{ label: v.aLabel || 'Start now', color: 'teal' }, { label: v.bLabel || 'Wait', color: 'amber' }])
      ]);
    }
    return null;
  }

  function buildInsight(s) {
    var vis = insightVisual(s.visual);
    return chrome(s, [
      el('div', { class: 'gpq-insight' }, [
        s.kicker ? el('div', { class: 'gpq-insight-kicker', 'data-reveal': '0' }, s.kicker) : null,
        el('h2', { class: 'gpq-insight-title', 'data-reveal': s.kicker ? '1' : '0', html: s.headline }),
        vis ? el('div', { class: 'gpq-ivis', 'data-reveal': s.kicker ? '2' : '1' }, vis) : null,
        el('p', { class: 'gpq-insight-body', 'data-reveal': (s.kicker ? 2 : 1) + (vis ? 1 : 0) + '', html: s.body })
      ])
    ], el('div', { class: 'gpq-foot' }, el('button', { class: 'gpq-btn gpq-btn--pill', onclick: function () { advance(s); } }, s.button || 'Continue')));
  }

  /* name and email are separate screens (mirrors the live quiz) */
  function buildName(s) {
    var wrap = el('div', { class: 'gpq-capture' }, [
      el('h2', { class: 'gpq-question', html: s.headline || "What's your first name?" }),
      s.subhead ? el('p', { class: 'gpq-qsub', html: s.subhead }) : null,
      el('input', { class: 'gpq-input', id: 'gpqName', type: 'text', placeholder: s.placeholder || 'First name', autocomplete: 'given-name', value: state.answers.name || '' }),
      el('div', { class: 'gpq-field-err', id: 'gpqErr' })
    ]);
    var foot = el('div', { class: 'gpq-foot' }, el('button', { class: 'gpq-btn gpq-btn--pill', onclick: function () { submitName(s); } }, s.button || 'Continue'));
    var v = chrome(s, [wrap], foot);
    v.querySelector('.gpq-input').addEventListener('keydown', function (e) { if (e.key === 'Enter') submitName(s); });
    return v;
  }

  function submitName(s) {
    var nameEl = document.getElementById('gpqName');
    var err = document.getElementById('gpqErr');
    var name = (nameEl.value || '').trim();
    err.textContent = '';
    if (name.length < 1) { err.textContent = 'Please enter your first name.'; nameEl.focus(); return; }
    state.answers.name = name;
    save();
    advance(s);
  }

  function buildCapture(s) {
    var wrap = el('div', { class: 'gpq-capture' }, [
      el('div', { class: 'gpq-capture-badge' }, [icon('sparkle'), s.badge || 'Your results are ready']),
      el('h2', { class: 'gpq-question', html: tpl(s.headline) }),
      el('p', { class: 'gpq-qsub', html: s.subhead }),
      el('input', { class: 'gpq-input', id: 'gpqEmail', type: 'email', placeholder: s.emailPlaceholder || 'you@email.com', autocomplete: 'email', value: state.answers.email || '' }),
      el('div', { class: 'gpq-field-err', id: 'gpqErr' }),
      s.belowField ? el('p', { class: 'gpq-capture-lead', html: s.belowField }) : null
    ]);
    var foot = el('div', { class: 'gpq-foot' }, [
      el('button', { class: 'gpq-btn gpq-btn--pill', onclick: submitCapture }, s.button || 'Show me my plan'),
      el('p', { class: 'gpq-microcopy', html: s.microcopy || "We'll never spam you. Unsubscribe anytime." })
    ]);
    var v = chrome(s, [wrap], foot);
    v.querySelectorAll('.gpq-input').forEach(function (i) {
      i.addEventListener('keydown', function (e) { if (e.key === 'Enter') submitCapture(); });
    });
    return v;
  }

  /* ---------- interactions ---------- */
  var pendingAdvance = false;
  function pick(s, o) {
    if (animating || pendingAdvance) return;
    state.answers[s.key] = o.value;
    save();
    gpTrack('answer_selected', {
      screen_id: s.id,
      screen_type: s.type,
      step_index: indexOf(s.id),
      key: s.prop || s.key,
      value: o.value,
      label: o.label
    });
    var scr = root.querySelector('.gpq-screen');
    if (scr) scr.querySelectorAll('.gpq-option').forEach(function (b) { b.classList.remove('is-selected'); b.setAttribute('aria-checked', 'false'); });
    /* mark clicked */
    var btns = scr ? scr.querySelectorAll('.gpq-option') : [];
    (s.options || []).forEach(function (opt, i) { if (opt.value === o.value && btns[i]) { btns[i].classList.add('is-selected'); btns[i].setAttribute('aria-checked', 'true'); } });
    pendingAdvance = true;
    setTimeout(function () { pendingAdvance = false; advance(s); }, 300);
  }

  function advance(s) {
    if (animating) return; /* transition lock: prevents overlapping swaps stacking screens */
    var nid = nextId(s);
    if (!nid) return;
    state.history.push(nid);
    render(nid, false);
  }

  function goBack() {
    if (animating) return; /* transition lock: prevents overlapping swaps stacking screens */
    if (state.history.length <= 1) return;
    state.history.pop();
    /* never land back on an auto-advancing screen (e.g. the loading animation) */
    var prev = screenById(state.history[state.history.length - 1]);
    while (prev && prev.type === 'loading' && state.history.length > 1) {
      state.history.pop();
      prev = screenById(state.history[state.history.length - 1]);
    }
    var backTo = state.history[state.history.length - 1];
    gpTrack('screen_back', { screen_id: backTo, step_index: indexOf(backTo) });
    render(backTo, true);
  }

  var _captureSubmitting = false;
  function submitCapture() {
    if (_captureSubmitting) return;
    var emailEl = document.getElementById('gpqEmail');
    var err = document.getElementById('gpqErr');
    var email = (emailEl.value || '').trim();
    err.textContent = '';
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) { err.textContent = 'Please enter a valid email address.'; emailEl.focus(); return; }
    _captureSubmitting = true;
    state.answers.email = email;
    save();
    kIdentify(); kSubscribe();
    kTrack('Quiz Email Captured', { persona: CFG.key });
    gpTrack('email_captured', {
      email: email,
      first_name: state.answers.name || null,
      consent_email: 1
    });
    finish();
  }

  /* ---------- loading (live-quiz pattern: eased bar + step milestones;
       style:'percent' = PSL pattern: big % counter + rotating statements) ---------- */
  function buildLoading(s) {
    if (s.style === 'percent') {
      return chrome(s, [
        el('div', { class: 'gpq-loading gpq-loading--pct' }, [
          el('div', { class: 'gpq-loading-pct' }, '0%'),
          el('div', { class: 'gpq-loading-bar-wrap' }, el('div', { class: 'gpq-loading-bar' })),
          el('p', { class: 'gpq-loading-stmt', 'aria-live': 'polite' }, (s.statements || [])[0] || '')
        ])
      ]);
    }
    return chrome(s, [
      el('div', { class: 'gpq-loading' }, [
        el('h2', { class: 'gpq-loading-title' }, s.title || 'Analyzing your results...'),
        el('div', { class: 'gpq-loading-bar-wrap' }, el('div', { class: 'gpq-loading-bar' })),
        el('div', { class: 'gpq-loading-steps', 'aria-live': 'polite' }, (s.lines || []).map(function (line, i) {
          return el('div', { class: 'gpq-loading-step', 'data-i': i }, [
            el('span', { class: 'gpq-loading-check' }, svg('<svg viewBox="0 0 14 14" fill="none"><path d="M2 7l3.5 3.5L12 4" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>')),
            el('span', { html: line })
          ]);
        }))
      ])
    ]);
  }

  function runLoadingPercent(s) {
    var bar = root.querySelector('.gpq-loading-bar');
    var pctEl = root.querySelector('.gpq-loading-pct');
    var stmtEl = root.querySelector('.gpq-loading-stmt');
    var stmts = s.statements || [];
    var duration = s.durationMs || 4200;
    if (REDUCED_MOTION) {
      if (bar) bar.style.width = '100%';
      if (pctEl) pctEl.textContent = '100%';
      setTimeout(function () { advance(s); }, 900);
      return;
    }
    var start = null, si = 0;
    function easeInOutCubic(t) { return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2; }
    function tick(ts) {
      if (!start) start = ts;
      var t = Math.min((ts - start) / duration, 1);
      var p = easeInOutCubic(t);
      if (bar) bar.style.width = (p * 100) + '%';
      if (pctEl) pctEl.textContent = Math.round(p * 100) + '%';
      var want = Math.min(stmts.length - 1, Math.floor(t * stmts.length));
      if (stmtEl && want !== si && stmts[want] != null) {
        si = want;
        stmtEl.classList.add('is-swap');
        (function (txt) { setTimeout(function () { stmtEl.innerHTML = txt; stmtEl.classList.remove('is-swap'); }, 180); })(stmts[si]);
      }
      if (t < 1) requestAnimationFrame(tick);
      else setTimeout(function () { advance(s); }, 500);
    }
    setTimeout(function () { requestAnimationFrame(tick); }, 600);
  }

  function runLoading(s) {
    if (s.style === 'percent') { runLoadingPercent(s); return; }
    var bar = root.querySelector('.gpq-loading-bar');
    var steps = Array.prototype.slice.call(root.querySelectorAll('.gpq-loading-step'));
    if (REDUCED_MOTION) {
      if (bar) bar.style.width = '100%';
      steps.forEach(function (st) { st.classList.add('is-visible', 'is-done'); });
      setTimeout(function () { advance(s); }, 900);
      return;
    }

    /* Stagger the step rows into view */
    steps.forEach(function (st, i) {
      setTimeout(function () {
        st.classList.add('is-visible');
        if (i === 0) st.classList.add('is-active');
      }, 200 + i * 200);
    });

    /* Eased progress bar with step-completion milestones */
    var duration = 3600;
    var ats = steps.length === 3 ? [0.30, 0.62, 1] : steps.map(function (_, i) { return (i + 1) / steps.length; });
    var start = null, mi = 0;
    function easeInOutCubic(t) { return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2; }
    function tick(ts) {
      if (!start) start = ts;
      var t = Math.min((ts - start) / duration, 1);
      if (bar) bar.style.width = (easeInOutCubic(t) * 100) + '%';
      while (mi < steps.length && t >= ats[mi]) {
        steps[mi].classList.remove('is-active');
        steps[mi].classList.add('is-done');
        if (steps[mi + 1]) steps[mi + 1].classList.add('is-active');
        mi++;
      }
      if (t < 1) requestAnimationFrame(tick);
      else setTimeout(function () { advance(s); }, 400); /* brief beat before the reveal */
    }
    /* let the screen settle before the bar starts moving */
    setTimeout(function () { requestAnimationFrame(tick); }, 700);
  }

  /* ============================================================
     RESULTS
     ============================================================ */
  function finish() {
    state.completed = true;
    if (!state.timerStart) state.timerStart = Date.now();
    save();
    kIdentify();
    kTrack('Quiz Completed', { persona: CFG.key, goal: state.answers[CFG.goalKey] });
    gpTrack('quiz_completed', { goal: state.answers[CFG.goalKey] || null });
    renderResults(true);
  }

  function firstName() {
    var n = (state.answers.name || '').trim().split(/\s+/)[0];
    if (!n) return null;
    if (n.length > 2 && n === n.toUpperCase()) n = n.charAt(0) + n.slice(1).toLowerCase();
    return n.charAt(0).toUpperCase() + n.slice(1);
  }

  /* Replace the [First Name] token; with no captured name, drop it and its
     surrounding punctuation so headlines still read naturally
     ("Good news, X: ..." -> "Good news: ..."; "X, your plan..." -> "Your plan..."). */
  function tpl(str) {
    str = str || '';
    var n = firstName();
    if (n) return str.replace(/\[First Name\]/g, n);
    return str
      .replace(/,\s*\[First Name\]/g, '')
      .replace(/^\[First Name\],\s*(.)/, function (m, c) { return c.toUpperCase(); })
      .replace(/\s*\[First Name\]\s*/g, ' ')
      .replace(/\s{2,}/g, ' ')
      .trim();
  }

  function resolveChip(chip) {
    if (typeof chip === 'string') return chip;
    if (chip.showIf) {
      var vals = chip.showIf.values || [];
      if (vals.indexOf(state.answers[chip.showIf.key]) === -1) return null;
    }
    if (chip.fromAnswer) {
      var scr = screenById(chip.fromAnswer);
      var ans = scr ? state.answers[scr.key] : null;
      if (ans == null) return chip.text || null;
      var lbl = labelFor(scr, ans);
      if (chip.map) lbl = chip.map[ans] || lbl;
      return lbl ? (chip.prefix || '') + lbl + (chip.suffix || '') : null;
    }
    return chip.text || null;
  }

  function activeResults() {
    var base = CFG.results;
    var variants = CFG.resultVariants;
    if (!variants || !variants.key || !variants.map) return base;
    var override = variants.map[state.answers[variants.key]] || variants.map._;
    return override ? Object.assign({}, base, override) : base;
  }

  function goalLine(results) {
    var r = results.recommendation;
    var g = state.answers[CFG.goalKey];
    return (r.goalMatched && (r.goalMatched[g] || r.goalMatched._)) || '';
  }

  function verdictCopy(results) {
    var v = results.verdict;
    if (v.genericWhen && v.genericWhen.values.indexOf(state.answers[v.genericWhen.key]) !== -1 && v.generic) {
      return v.generic;
    }
    return v;
  }

  function renderResults(fresh) {
    root.innerHTML = '';
    var R = activeResults();
    var page = el('div', { class: 'gpr' });

    /* header */
    page.appendChild(el('header', { class: 'gpr-head' + (CFG.showBrand === false ? ' gpr-head--nobrand' : '') }, [
      CFG.showBrand === false ? null : el('span', { class: 'gpr-wordmark' }, CFG.brand ? CFG.brand.toUpperCase() : 'GROWPLEX'),
      el('span', { class: 'gpr-head-right' }, 'Your results')
    ]));

    /* 1. verdict hero — full-bleed dark band, centered, minimal copy.
       The decision card overlaps its bottom edge (verdict → plan, no gap),
       the pattern the big quiz brands use: diagnosis, then the answer. */
    var V = verdictCopy(R);
    var chips = (V.chips || []).map(resolveChip).filter(Boolean);
    page.appendChild(el('section', { class: 'gpr-hero' }, el('div', { class: 'gpr-hero-inner' }, [
      el('div', { class: 'gpr-badge' }, [icon('check'), V.badge || 'Assessment complete']),
      el('h1', { class: 'gpr-verdict-title', html: tpl(V.headline) }),
      el('div', { class: 'gpr-chips' }, chips.map(function (c) { return el('span', { class: 'gpr-chip', html: c }); })),
      V.body ? el('p', { class: 'gpr-verdict-body', html: tpl(V.body) }) : null
    ])));

    var main = el('div', { class: 'gpr-main' });
    page.appendChild(main);

    var planSec = planCard(R.recommendation, R.offer);
    var profSec = profile(R.profile);
    var mechSec = mechanism(R.mechanism);
    var bridgeSec = bridgeSection(R.bridge);
    /* the standalone bridge already says the closing line above the plan;
       don't repeat it under the what's-inside cards */
    var insideBridge = (bridgeSec && R.bridge) ? { items: R.bridge.items } : R.bridge;
    var insideSec = whatsInside(R.recommendation, insideBridge);
    var tlSec = timeline(R.timeline);
    var looxSec = R.loox ? looxSection(R.loox) : (R.social ? socialProof(R.social) : null);
    var faqSec = faq(R.faq);

    /* Single narrative column (mobile and desktop): verdict hero → profile →
       mechanism → bridge → plan → what's inside → 90-day timeline → reviews → faq. */
    main.appendChild(el('div', { class: 'gpr-layout' }, [
      el('div', { class: 'gpr-narrative' }, [profSec, mechSec, bridgeSec, planSec, insideSec, tlSec, looxSec, faqSec].filter(Boolean))
    ]));

    /* footer */
    if (R.footer) {
      page.appendChild(el('footer', { class: 'gpr-foot' }, [
        el('p', { class: 'gpr-disclaimer', html: R.footer.disclaimer }),
        R.footer.resultsVary ? el('p', { class: 'gpr-disclaimer', html: R.footer.resultsVary }) : null
      ]));
    }

    root.appendChild(page);
    stickyBar(R.recommendation);
    if (GPX) {
      gpTrack('result_viewed', { fresh: !!fresh });
      /* the plan card (price + button) coming into view is "saw the offer" */
      var plan = root.querySelector('.gpr-bundle');
      if (plan && 'IntersectionObserver' in window) {
        var seenOffer = false;
        var io = new IntersectionObserver(function (entries) {
          if (seenOffer || !entries[0].isIntersecting) return;
          seenOffer = true;
          io.disconnect();
          gpTrack('offer_viewed', {});
        }, { threshold: 0.4 });
        io.observe(plan);
      }
    }
    ensureCartDrawer(); /* pre-warm so the first Add to Cart opens instantly */
    startTimer();
    if (fresh) window.scrollTo({ top: 0 });
  }

  /* resolve a raw config value that may map from an answer:
     {fromAnswer:'q3', map:{...}, _: fallback} | literal number/string */
  function fromAnswerValue(spec, fallback) {
    if (spec == null) return fallback;
    if (typeof spec === 'number' || typeof spec === 'string') return spec;
    var scr = spec.fromAnswer ? screenById(spec.fromAnswer) : null;
    var ans = scr ? state.answers[scr.key] : undefined;
    if (spec.map && ans != null && spec.map[ans] != null) return spec.map[ans];
    if (spec._ != null) return spec._;
    return fallback;
  }

  /* ---- profile summary (answer-echo scale + callout + stat tiles) ---- */
  function profile(P) {
    if (!P) return null;
    var card = el('div', { class: 'gpr-profile' });
    if (P.scale) {
      var pos = fromAnswerValue(P.scale.pos, 0.5);
      var badge = P.scale.badge ? resolveChip(P.scale.badge) : null;
      card.appendChild(el('div', { class: 'gpr-scale' }, [
        el('div', { class: 'gpr-scale-top' }, [
          el('div', { class: 'gpr-scale-title', html: P.scale.title || '' }),
          badge ? el('span', { class: 'gpr-scale-badge' }, badge) : null
        ]),
        el('div', { class: 'gpr-scale-bar' }, el('span', { class: 'gpr-scale-dot', style: 'left:' + Math.round(pos * 100) + '%' })),
        el('div', { class: 'gpr-scale-labels' }, (P.scale.labels || []).map(function (l) { return el('span', {}, l); }))
      ]));
    }
    if (P.callout) {
      card.appendChild(el('div', { class: 'gpr-profile-callout' }, [
        el('div', { class: 'gpr-profile-callout-ic' }, icon('check')),
        el('div', {}, [
          P.callout.title ? el('div', { class: 'gpr-profile-callout-title', html: tpl(P.callout.title) }) : null,
          P.callout.body ? el('p', { class: 'gpr-profile-callout-body', html: tpl(P.callout.body) }) : null
        ])
      ]));
    }
    if (P.items && P.items.length) {
      card.appendChild(el('div', { class: 'gpr-profile-grid' }, P.items.map(function (it) {
        return el('div', { class: 'gpr-profile-item' }, [
          el('div', { class: 'gpr-profile-item-label' }, it.label || ''),
          el('div', { class: 'gpr-profile-item-value' }, resolveChip(it.value) || '')
        ]);
      })));
    }
    return section([
      el('h2', { class: 'gpr-h2', html: P.header || 'Your hair profile' }),
      card
    ], 'gpr-prof');
  }

  /* ---- 90-day projection timeline (ascending curve + milestones) ---- */
  function timeline(T) {
    if (!T) return null;
    var m = T.markers || [];
    var tag = (m[0] && m[0].tag) || "YOU'RE HERE";
    var curve = svg('<svg class="gpr-tl-svg" viewBox="0 0 320 132" fill="none" aria-hidden="true">' +
      '<path d="M20 112 C 70 106, 115 88, 160 60 C 205 33, 255 24, 300 20 L 300 132 L 20 132 Z" fill="#4f9078" opacity="0.08"/>' +
      '<path d="M20 112 C 70 106, 115 88, 160 60 C 205 33, 255 24, 300 20" stroke="#4f9078" stroke-width="3" stroke-linecap="round"/>' +
      '<circle cx="160" cy="60" r="5" fill="#4f9078"/>' +
      '<circle cx="300" cy="20" r="5" fill="#4f9078"/>' +
      '<circle cx="20" cy="112" r="6" fill="#1b2a30"/>' +
      '<rect x="8" y="76" width="84" height="21" rx="10.5" fill="#1b2a30"/>' +
      '<text x="50" y="90" text-anchor="middle" font-family="Inter, sans-serif" font-size="9" font-weight="700" letter-spacing="0.5" fill="#f4f2ec">' + tag.toUpperCase() + '</text>' +
      '</svg>');
    return section([
      el('h2', { class: 'gpr-h2', html: T.header || 'What the first 90 days look like' }),
      el('div', { class: 'gpr-tl-card' }, [
        curve,
        el('div', { class: 'gpr-tl-cols' }, m.map(function (mk) {
          var dateStr = null;
          if (mk.days != null) {
            try { dateStr = new Date(Date.now() + mk.days * 864e5).toLocaleDateString('en-US', { month: 'short', day: 'numeric' }); } catch (e) {}
          }
          return el('div', { class: 'gpr-tl-col' }, [
            el('div', { class: 'gpr-tl-label' }, mk.label || ''),
            dateStr ? el('div', { class: 'gpr-tl-date' }, dateStr) : null,
            mk.note ? el('div', { class: 'gpr-tl-note', html: mk.note }) : null
          ]);
        })),
        T.caption ? el('p', { class: 'gpr-tl-caption', html: T.caption }) : null
      ])
    ], 'gpr-tl');
  }

  /* ---- mechanism section ---- */
  function mechanism(M) {
    if (!M) return null;
    return section([
      el('h2', { class: 'gpr-h2', html: M.header }),
      mechanismGraphic(M),
      M.caption ? el('p', { class: 'gpr-caption', html: M.caption }) : null,
      M.closing ? el('div', { class: 'gpr-takeaway' }, [icon('check'), el('span', { html: M.closing })]) : null
    ], 'gpr-mech');
  }

  /* ---- bridge: "recovery takes two things" education step between the
     mechanism and the buy box. Names the two needs BEFORE products appear so
     the bundle reads as the answer, not an upsell. Text and icons only:
     no product names, no prices, no bottle images (per the dev handoff).
     Renders only for the new config shape (eyebrow/intro present). ---- */
  function bridgeSection(B) {
    if (!B || (!B.eyebrow && !B.intro)) return null;
    return section([
      el('div', { class: 'gpr-eyebrow' }, B.eyebrow),
      el('h2', { class: 'gpr-h2', html: B.header }),
      B.intro ? el('p', { class: 'gpr-bridge-intro', html: B.intro }) : null,
      el('div', { class: 'gpr-bridge-cards' }, (B.items || []).map(function (it, i) {
        return el('div', { class: 'gpr-bridge-card' }, [
          el('div', { class: 'gpr-bridge-ic' }, bridgeIcon(it.icon)),
          el('div', { class: 'gpr-bridge-tg' }, [
            el('div', { class: 'gpr-bridge-label' }, it.label || ('Need ' + (i + 1))),
            el('div', { class: 'gpr-bridge-title', html: it.title }),
            el('p', { class: 'gpr-bridge-body', html: it.body }),
            (function () {
              var reason = fromAnswerValue(it.reason, null);
              return reason ? el('div', { class: 'gpr-bridge-reason' }, reason) : null;
            })()
          ])
        ]);
      })),
      B.closing ? el('div', { class: 'gpr-bridge-close' }, [
        el('strong', { html: B.closing }),
        B.closingSub ? el('div', { class: 'gpr-bridge-close-sub' }, B.closingSub) : null,
        el('div', { class: 'gpr-bridge-chev', 'aria-hidden': 'true' }, svg('<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M6 9l6 6 6-6"/></svg>'))
      ]) : null
    ], 'gpr-bridge');
  }
  function bridgeIcon(name) {
    /* inside = nutrients rising from within; scalp = a drop landing at the surface */
    if (name === 'scalp') return svg('<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 3.5c2.9 3.4 5.5 6.4 5.5 9.4a5.5 5.5 0 0 1-11 0c0-3 2.6-6 5.5-9.4z"/></svg>');
    return svg('<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 19V6"/><path d="M7.5 10.5L12 6l4.5 4.5"/><path d="M5 19h14"/></svg>');
  }

  /* ---- sticky mobile buy bar (desktop uses the sticky rail instead) ---- */
  function stickyBar(R) {
    var bundle = CFG.products[R.bundleKey] || {};
    var offer = CFG.results && CFG.results.offer;
    var foPct = offer && offer.firstOrderPct > 0 ? offer.firstOrderPct : 0;
    var bar = el('div', { class: 'gpr-sticky' }, [
      el('div', { class: 'gpr-sticky-price' }, [
        el('strong', { id: 'gprStickyPrice' }, (function () {
          var pr = selectedTier ? selectedTier.price : bundle.price;
          if (pr != null && foPct) pr = Math.round(pr * (100 - foPct) / 100);
          return pr != null ? money(pr) : '';
        })()),
        el('span', { class: 'gpr-sticky-per', id: 'gprStickySuffix' }, foPct ? ' first order' : ((selectedTier && selectedTier.months > 1) ? ('/' + selectedTier.months + ' months') : (R.priceSuffix || '/month')))
      ]),
      el('button', { class: 'gpr-cta gpr-cta--primary gpr-sticky-cta', onclick: function (e) {
        if (R.ctaUrl) { window.location.href = R.ctaUrl; return; }
        addToCart(e.currentTarget, bundle, true);
      } }, [
        el('span', { class: 'gpr-cta-text' }, R.cta || 'Start my plan'), el('span', { class: 'gpr-cta-spin' })
      ])
    ]);
    root.querySelector('.gpr').appendChild(bar);
    var target = root.querySelector('.gpr-bundle');
    if (!target || !('IntersectionObserver' in window)) return;
    new IntersectionObserver(function (entries) {
      var e = entries[0];
      /* show only after the plan card has scrolled up out of view */
      bar.classList.toggle('is-show', !e.isIntersecting && e.boundingClientRect.top < 0);
    }, { threshold: 0 }).observe(target);
  }

  function section(kids, extra) {
    return el('section', { class: 'gpr-section' + (extra ? ' ' + extra : '') }, kids);
  }

  /* ---- mechanism graphic: generated illustration (results page) or SVG ---- */
  function mechanismGraphic(M) {
    if (M.image && (M.image.asset || M.image.src)) {
      return el('div', { class: 'gpr-mech-imgwrap' }, [
        el('img', { class: 'gpr-mech-img', src: M.image.src || assetUrl(M.image.asset), alt: M.image.alt || '', loading: 'lazy' }),
        M.stages ? el('div', { class: 'gpr-mech-img-labels' }, M.stages.map(function (st) {
          return el('div', { class: 'gpr-mech-img-col' }, [
            el('div', { class: 'gpr-mech-label-main' }, st.label),
            st.sub ? el('div', { class: 'gpr-mech-label-sub' }, st.sub) : null
          ]);
        })) : null
      ]);
    }
    var stages = M.stages || [];
    var wrap = el('div', { class: 'gpr-mech-graphic' });
    var row = el('div', { class: 'gpr-mech-row' });
    stages.forEach(function (st, i) {
      if (i > 0) row.appendChild(el('div', { class: 'gpr-mech-arrow', 'aria-hidden': 'true' },
        svg('<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14"/><path d="M13 6l6 6-6 6"/></svg>')));
      var col = el('div', { class: 'gpr-mech-col' });
      col.appendChild(M.type === 'follicles' ? follicleSVG(st) : barsSVG(st));
      col.appendChild(el('div', { class: 'gpr-mech-label' }, [
        el('span', { class: 'gpr-mech-label-main' }, st.label),
        st.sub ? el('span', { class: 'gpr-mech-label-sub' }, st.sub) : null
      ]));
      row.appendChild(col);
    });
    wrap.appendChild(row);
    return wrap;
  }
  function stageColor(st) { return st.color === 'amber' ? 'var(--amber)' : st.color === 'amber2' ? 'var(--amber-deep)' : 'var(--teal)'; }
  function barsSVG(st) {
    var c = stageColor(st);
    var h = st.h != null ? st.h : 1;              /* 0..1 strand height */
    var heights = [0.78, 1, 0.72].map(function (m) { return Math.round(46 * h * m); });
    var xs = [16, 27, 38];
    var lines = heights.map(function (hh, i) {
      var y2 = 52, y1 = 52 - Math.max(6, hh);
      return '<line x1="' + xs[i] + '" y1="' + y1 + '" x2="' + xs[i] + '" y2="' + y2 + '" stroke="' + c + '" stroke-width="3.4" stroke-linecap="round"/>';
    }).join('');
    return svg('<svg class="gpr-mech-svg" viewBox="0 0 54 56">' + lines + '</svg>');
  }
  function follicleSVG(st) {
    var c = stageColor(st);
    var h = st.h != null ? st.h : 1;
    var stemTop = 52 - Math.round(40 * h);
    var bulbR = 4 + 4 * h;
    return svg('<svg class="gpr-mech-svg" viewBox="0 0 54 56">' +
      '<line x1="27" y1="' + (52 - bulbR) + '" x2="27" y2="' + stemTop + '" stroke="' + c + '" stroke-width="3.4" stroke-linecap="round"/>' +
      '<circle cx="27" cy="' + (52 - bulbR) + '" r="' + bulbR + '" fill="' + c + '" opacity="0.9"/>' +
      '</svg>');
  }

  /* ---- recommendation (the plan) ----
     The brief's "bridge" (two needs: inside + outside) is folded in here:
     each product card carries its bridge concept as a kicker, and the
     bridge closing line sits between the cards and the bundle card. */
  /* The decision card — everything needed to say yes, nothing else.
     Straddles the hero band edge so the plan is visible with the verdict. */
  function planCard(R, offer) {
    var P = CFG.products;
    var bundle = P[R.bundleKey] || {};
    var priceCents = bundle.price != null ? bundle.price : null;
    var compareCents = bundle.compareAt != null ? bundle.compareAt : null;
    var tiers = bundle.tiers || [];
    /* 3-month cadence is the pre-selected default, mirroring the PDPs */
    if (tiers.length) {
      selectedTier = tiers.filter(function (t) { return t.months === 3; })[0] || tiers[0];
    }

    function finePrintFor(months) {
      var base = R.finePrint || '';
      var cadence = months > 1 ? 'delivered every ' + months + ' months' : 'delivered monthly';
      return base.replace('delivered monthly', cadence);
    }
    /* First-order pricing: when the offer declares firstOrderPct, the first charge is that
       much below the subscription price (a checkout-side automatic discount), and renewals
       bill the subscription price. Without it, behaviour is unchanged. */
    var foPct = offer && offer.firstOrderPct > 0 ? offer.firstOrderPct : 0;
    function firstOrder(price) { return (foPct && price != null) ? Math.round(price * (100 - foPct) / 100) : price; }
    function suffixFor(months) { return months > 1 ? '/' + months + ' months' : (R.priceSuffix || '/month'); }
    function renewalText(price, months) {
      var t = (offer && offer.renewalNote) || 'Then {price}{suffix}';
      return t.replace('{price}', money(price)).replace('{suffix}', suffixFor(months));
    }
    function priceRowKids(price, compare, months) {
      var shown = firstOrder(price);
      var save = (compare && shown) ? compare - shown : null;
      return [
        el('span', { class: 'gpr-price' }, [
          shown != null ? money(shown) : '$XX',
          el('span', { class: 'gpr-price-per' }, foPct ? ' first order' : suffixFor(months))
        ]),
        compare ? el('span', { class: 'gpr-price-was' }, money(compare)) : null,
        save ? el('span', { class: 'gpr-price-save' }, 'Save ' + money(save)) : null,
        foPct && price != null ? el('span', { class: 'gpr-renew', id: 'gprRenew' }, renewalText(price, months)) : null
      ].filter(Boolean);
    }
    var priceRow = el('div', { class: 'gpr-bundle-price' }, priceRowKids(
      tiers.length ? selectedTier.price : priceCents,
      tiers.length ? selectedTier.compareAt : compareCents,
      tiers.length ? selectedTier.months : 1));

    /* delivery cadence picker (1 / 3 / 6 months) */
    var picker = null;
    if (tiers.length > 1) {
      picker = el('div', { class: 'gpr-tiers', role: 'radiogroup', 'aria-label': 'Delivery frequency' }, tiers.map(function (t) {
        return el('button', { class: 'gpr-tier' + (t === selectedTier ? ' is-selected' : ''), role: 'radio', 'aria-checked': t === selectedTier ? 'true' : 'false', onclick: function () {
          selectedTier = t;
          Array.prototype.forEach.call(picker.querySelectorAll('.gpr-tier'), function (b, i) {
            var sel = tiers[i] === t;
            b.classList.toggle('is-selected', sel);
            b.setAttribute('aria-checked', sel ? 'true' : 'false');
          });
          while (priceRow.firstChild) priceRow.removeChild(priceRow.firstChild);
          priceRowKids(t.price, t.compareAt, t.months).forEach(function (n) { priceRow.appendChild(n); });
          var sp = document.getElementById('gprStickyPrice');
          if (sp) sp.textContent = money(firstOrder(t.price));
          var ss = document.getElementById('gprStickySuffix');
          if (ss) ss.textContent = foPct ? ' first order' : suffixFor(t.months);
          var fp = document.getElementById('gprFinePrint');
          if (fp) fp.innerHTML = finePrintFor(t.months);
        } }, [
          el('span', { class: 'gpr-tier-radio' }),
          el('span', { class: 'gpr-tier-tg' }, [
            el('span', { class: 'gpr-tier-top' }, [
              el('span', { class: 'gpr-tier-label' }, t.months === 1 ? 'Monthly delivery' : t.months + '-month delivery'),
              (t.compareAt && t.compareAt > firstOrder(t.price)) ? el('span', { class: 'gpr-tier-save' }, 'Save ' + money(Math.round((t.compareAt - firstOrder(t.price)) / 100) * 100)) : null
            ]),
            el('span', { class: 'gpr-tier-desc' }, t.months === 1 ? '1 kit shipped every month.' : t.months + ' kits shipped every ' + t.months + ' months.'),
            el('span', { class: 'gpr-tier-desc gpr-tier-desc--soft' }, 'Free shipping. Pause or cancel anytime.')
          ]),
          el('span', { class: 'gpr-tier-price' }, [
            el('span', { class: 'gpr-tier-price-now' }, money(firstOrder(t.price))),
            (t.compareAt && t.compareAt > firstOrder(t.price)) ? el('span', { class: 'gpr-tier-price-was' }, money(t.compareAt)) : null
          ])
        ]);
      }));
    }

    var duoKids = [];
    (R.productKeys || []).forEach(function (key, i) {
      var p = P[key] || {};
      var meta = (R.productMeta && R.productMeta[key]) || {};
      var img = p.image ? el('img', { class: 'gpr-duo-img', src: p.image, alt: meta.name || p.title || '', loading: 'lazy' }) : el('span', { class: 'gpr-duo-img gpr-prod-img--ph' });
      if (i > 0) duoKids.push(el('span', { class: 'gpr-duo-plus', 'aria-hidden': 'true' }, '+'));
      duoKids.push(el('span', { class: 'gpr-duo-item' }, [img, el('span', { class: 'gpr-duo-name' }, meta.name || p.title || key)]));
    });
    var duo = el('div', { class: 'gpr-duo' }, duoKids);

    var card = el('div', { class: 'gpr-bundle' }, [
      el('div', { class: 'gpr-bundle-head' }, [
        el('div', {}, [
          el('div', { class: 'gpr-eyebrow' }, R.eyebrow || 'Your recommended plan'),
          el('h2', { class: 'gpr-bundle-title', html: R.header })
        ]),
        el('span', { class: 'gpr-bundle-tag gpr-bundle-tag--offer' }, (offer && offer.chip) || '20% off')
      ]),
      duo,
      priceRow,
      picker,
      el('div', { class: 'gpr-goal', html: goalLine(activeResults()) }),
      offer && offer.showTimer === false ? null : el('div', { class: 'gpr-timer-wrap' }, [
        el('span', { class: 'gpr-timer', id: 'gprTimer' }, '15:00'),
        el('span', { class: 'gpr-timer-note' }, (offer && offer.timerNote) || 'reserved for you')
      ]),
      el('button', { class: 'gpr-cta gpr-cta--primary', onclick: function (e) {
        if (R.ctaUrl) { window.location.href = R.ctaUrl; return; }
        addToCart(e.currentTarget, bundle, true);
      } }, [
        el('span', { class: 'gpr-cta-text' }, R.cta || 'Start my plan'), el('span', { class: 'gpr-cta-spin' })
      ]),
      R.finePrint ? el('p', { class: 'gpr-plan-note', id: 'gprFinePrint', html: finePrintFor(tiers.length ? selectedTier.months : 1) }) : null
    ]);

    return section([card], 'gpr-rec');
  }

  /* Supporting detail for scrollers: the two products with their bullets. */
  function whatsInside(R, bridge) {
    var P = CFG.products;
    var bItems = (bridge && bridge.items) || [];
    var cards = (R.productKeys || []).map(function (key, i) {
      var p = P[key] || {};
      var meta = (R.productMeta && R.productMeta[key]) || {};
      var bullets = meta.bullets || [];
      return el('div', { class: 'gpr-prod' }, [
        p.image ? el('img', { class: 'gpr-prod-img', src: p.image, alt: meta.name || p.title || '', loading: 'lazy' }) : el('div', { class: 'gpr-prod-img gpr-prod-img--ph' }),
        el('div', { class: 'gpr-prod-info' }, [
          bItems[i] ? el('div', { class: 'gpr-prod-kicker' }, (i + 1) + ' · ' + bItems[i].title) : null,
          el('div', { class: 'gpr-prod-name' }, el('strong', {}, meta.name || p.title || key)),
          bullets.length ? el('ul', { class: 'gpr-prod-bullets' }, bullets.map(function (b) {
            return el('li', {}, [icon('check'), el('span', { html: b })]);
          })) : (meta.desc ? el('p', { class: 'gpr-prod-desc', html: meta.desc }) : null)
        ])
      ]);
    });
    return section([
      el('h2', { class: 'gpr-h2', html: R.insideHeader || "What's inside your plan" }),
      el('div', { class: 'gpr-prods' }, cards),
      bridge && bridge.closing ? el('p', { class: 'gpr-both-line', html: bridge.closing }) : null
    ], 'gpr-inside');
  }

  /* ---- social proof: photos first (strongest asset), then quotes ---- */
  function socialProof(S) {
    var trustItems = (S.trustBar || '').split('·').map(function (t) { return t.trim(); }).filter(Boolean);
    return section([
      el('h2', { class: 'gpr-h2', html: S.header }),
      S.beforeAfter ? el('div', { class: 'gpr-ba' }, (S.beforeAfter || []).map(function (ba) {
        return el('div', { class: 'gpr-ba-item' }, [
          el('div', { class: 'gpr-ba-imgs' }, [
            el('div', { class: 'gpr-ba-img' + (ba.before ? '' : ' gpr-ba-img--ph') , style: ba.before ? 'background-image:url(' + ba.before + ')' : '' }, el('span', { class: 'gpr-ba-tag' }, 'Before')),
            el('div', { class: 'gpr-ba-img' + (ba.after ? '' : ' gpr-ba-img--ph'), style: ba.after ? 'background-image:url(' + ba.after + ')' : '' }, el('span', { class: 'gpr-ba-tag gpr-ba-tag--after' }, 'After'))
          ]),
          el('div', { class: 'gpr-ba-cap' }, ba.caption || '')
        ]);
      })) : null,
      el('div', { class: 'gpr-reviews' }, (S.reviews || []).map(function (r) {
        return el('div', { class: 'gpr-review' }, [
          el('div', { class: 'gpr-stars' }, stars(r.stars || 5)),
          el('p', { class: 'gpr-review-quote', html: '"' + r.quote + '"' }),
          el('div', { class: 'gpr-review-by' }, (r.name || '') + ' · ' + (r.tag || 'Verified buyer'))
        ]);
      })),
      el('div', { class: 'gpr-trust' }, trustItems.map(function (t) { return el('span', { class: 'gpr-trust-item' }, t); }))
    ], 'gpr-social');
  }

  /* ---- Loox reviews: the site-wide Loox loader polls for #looxReviews and
     populates it (verified on the live quiz layout); the widget takes a single
     product id, so we point it at our strongest review base (VitaFoam). ---- */
  function looxSection(L) {
    var pid = L.productId;
    if (!pid && L.productKey && CFG.products[L.productKey]) pid = CFG.products[L.productKey].productId;
    if (!pid) return null;
    return section([
      el('h2', { class: 'gpr-h2', html: L.header || 'What customers are saying' }),
      el('div', { id: 'looxReviews', 'data-product-id': String(pid) })
    ], 'gpr-loox');
  }
  function stars(n) {
    var out = [];
    for (var i = 0; i < 5; i++) out.push(el('span', { class: 'gpr-star' + (i < n ? '' : ' is-off'), html: '★' }));
    return out;
  }

  /* ---- timer (rendered inside the plan card) ---- */
  var timerInt = null;
  function startTimer() {
    var elm = document.getElementById('gprTimer');
    if (!elm) return;
    var total = (CFG.results.offer.timerMinutes || 15) * 60 * 1000;
    if (!state.timerStart) { state.timerStart = Date.now(); save(); }
    function tick() {
      var left = Math.max(0, total - (Date.now() - state.timerStart));
      var m = Math.floor(left / 60000), s = Math.floor((left % 60000) / 1000);
      elm.textContent = m + ':' + (s < 10 ? '0' : '') + s;
      if (left <= 0 && timerInt) { clearInterval(timerInt); }
    }
    tick();
    if (timerInt) clearInterval(timerInt);
    timerInt = setInterval(tick, 1000);
  }

  /* ---- faq accordion ---- */
  function faq(F) {
    if (!F) return null;
    return section([
      el('h2', { class: 'gpr-h2', html: F.header || 'Common questions' }),
      el('div', { class: 'gpr-faq' }, (F.items || []).map(function (it, i) {
        var aId = 'gprFaqA' + i;
        var body = el('div', { class: 'gpr-faq-a', id: aId }, el('div', { class: 'gpr-faq-a-inner', html: it.a }));
        var row = el('div', { class: 'gpr-faq-item' }, [
          el('button', { class: 'gpr-faq-q', 'aria-expanded': 'false', 'aria-controls': aId, onclick: function (e) {
            row.classList.toggle('is-open');
            var open = row.classList.contains('is-open');
            e.currentTarget.setAttribute('aria-expanded', open ? 'true' : 'false');
            body.style.maxHeight = open ? body.firstChild.offsetHeight + 'px' : '0px';
          } }, [ el('span', { html: it.q }), el('span', { class: 'gpr-faq-chev' }, svg('<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M6 9l6 6 6-6"/></svg>')) ]),
          body
        ]);
        return row;
      }))
    ], 'gpr-faqs');
  }

  /* ---- add to cart ----
     Prefers the exact variant (+ selling plan) injected by Liquid so the
     checkout price always matches the price shown on the page. The store's
     advertised prices are the "Deliver every 1 Month" Subscribe & Save tier;
     the first variant is the (more expensive) one-time purchase, so falling
     back to variants[0] is a last resort only. */
  var selectedTier = null; /* chosen delivery cadence for the kit */

  /* Lazily inject the theme's cart drawer (Section Rendering API). The quiz
     layout is chrome-less, so the drawer section isn't on the page by default;
     theme.js + js-variables are loaded by the snippet so the custom element
     upgrades and behaves exactly like on PDPs. */
  var drawerReady = null;
  function ensureCartDrawer() {
    if (drawerReady) return drawerReady;
    drawerReady = fetch('/?section_id=cart-drawer').then(function (r) {
      if (!r.ok) throw new Error('no drawer section');
      return r.text();
    }).then(function (html) {
      var tmp = document.createElement('div');
      tmp.innerHTML = html;
      var sec = tmp.firstElementChild;
      if (!sec || !sec.querySelector('cart-drawer')) throw new Error('no drawer markup');
      document.body.appendChild(sec);
      /* Scripts parsed via innerHTML never execute, so the section's inline
         script (binds the qty +/- buttons, remove buttons and the S&S toggle
         to #cart-drawer) has to be re-created to run. One pass is enough:
         the theme re-renders the drawer's children on cart:change, never the
         <cart-drawer> element itself, so the delegated listeners survive. */
      var inert = sec.querySelectorAll('script');
      for (var i = 0; i < inert.length; i++) {
        var live = document.createElement('script');
        if (inert[i].src) live.src = inert[i].src;
        live.textContent = inert[i].textContent;
        inert[i].parentNode.replaceChild(live, inert[i]);
      }
      /* wait (bounded) for theme.js to define the element */
      return Promise.race([
        window.customElements.whenDefined('cart-drawer').then(function () { return true; }),
        wait(4000).then(function () { return !!window.customElements.get('cart-drawer'); })
      ]);
    }).catch(function () { drawerReady = null; return false; });
    return drawerReady;
  }

  function addToCart(btn, p, isBundle) {
    p = p || {};
    if (!p.handle && !p.variantId) { window.location.href = '/cart'; return; }
    if (btn.classList.contains('is-loading')) return;
    btn.classList.add('is-loading');
    var tier = (isBundle && p.tiers && p.tiers.length) ? (selectedTier || p.tiers[0]) : null;
    kTrack('Quiz Add To Cart', { persona: CFG.key, handle: p.handle, bundle: !!isBundle, cadence: tier ? tier.months + 'mo' : undefined });
    gpTrack('add_to_cart', {
      handle: p.handle,
      bundle: !!isBundle,
      cadence: tier ? tier.months + 'mo' : null,
      value_cents: tier ? tier.price : (p.price || null)
    });
    var variantId = tier ? tier.variantId : p.variantId;
    var planId = tier ? tier.sellingPlanId : p.sellingPlanId;
    var itemPromise = variantId
      ? Promise.resolve({ id: variantId, selling_plan: planId || undefined, quantity: 1 })
      : fetch('/products/' + p.handle + '.js').then(function (r) { return r.json(); }).then(function (prod) { return { id: prod.variants[0].id, quantity: 1 }; });
    itemPromise.then(function (item) {
      return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: JSON.stringify({ items: [item], sections: 'cart-drawer' }) });
    }).then(function (r) {
      if (!r || !r.ok) throw new Error('add failed');
      return r.json();
    }).then(function (added) {
      /* legacy discount path still goes straight to checkout */
      if (CFG.discountCode) {
        window.location.href = '/discount/' + encodeURIComponent(CFG.discountCode) + '?redirect=' + encodeURIComponent('/checkout');
        return;
      }
      return ensureCartDrawer().then(function (ok) {
        if (!ok || !document.querySelector('cart-drawer')) { window.location.href = '/cart'; return; }
        return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
          cart.sections = added.sections;
          /* mirror the theme product form so the drawer refreshes and opens */
          document.dispatchEvent(new CustomEvent('variant:add', { bubbles: true, detail: { items: added.items || [added], cart: cart } }));
          document.documentElement.dispatchEvent(new CustomEvent('cart:change', { bubbles: true, detail: { baseEvent: 'variant:add', cart: cart } }));
          btn.classList.remove('is-loading');
        });
      });
    }).catch(function () { btn.classList.remove('is-loading'); });
  }

  /* ---- icons ---- */
  function icon(name) {
    if (name === 'check') return svg('<svg class="gpr-ic" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6L9 17l-5-5"/></svg>');
    if (name === 'sparkle') return svg('<svg class="gpr-ic" viewBox="0 0 24 24" fill="currentColor"><path d="M12 2l1.6 5.4L19 9l-5.4 1.6L12 16l-1.6-5.4L5 9l5.4-1.6z"/></svg>');
    return svg('<svg viewBox="0 0 24 24"></svg>');
  }

  /* checkout_started from a tap: the cart drawer's checkout button submits to
     /checkout and leaves the page, so the event is flushed immediately. The
     Shopify checkouts/create webhook records the same step server-side. */
  if (GPX) {
    document.addEventListener('click', function (e) {
      var t = e.target && e.target.closest && e.target.closest('button[name="checkout"], a[href$="/checkout"], a[href*="/checkout?"]');
      if (!t) return;
      gpTrack('checkout_started', { via: 'tap' });
      try { window.GPQuizTrack && window.GPQuizTrack.flush(); } catch (err) {}
    }, true);
  }

  /* ============================================================
     INIT
     ============================================================ */
  gpTrackInit();
  if (state.completed) {
    renderResults(false);
  } else {
    if (state.screenId === screens[0].id && !state.started) {
      state.started = true;
      save();
      kTrack('Quiz Started', { persona: CFG.key });
      /* fired BEFORE the first render so quiz_started always precedes the
         first screen_viewed in seq order */
      gpTrack('quiz_started', { step_index: 0, screen_id: screens[0].id });
    }
    render(state.screenId, false);
  }
})();
